(function () {
  'use strict';
  var KEY = 'artynov_wishlist_v1';
  var root = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function toggle(handle) {
    var a = read(), i = a.indexOf(handle);
    if (i === -1) a.push(handle); else a.splice(i, 1);
    write(a); return i === -1;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function syncButtons() {
    var saved = read();
    var btns = document.querySelectorAll('.js-wishlist-btn');
    for (var i = 0; i < btns.length; i++) {
      var on = saved.indexOf(btns[i].getAttribute('data-wishlist-handle')) !== -1;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  function syncCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n > 0) els[i].removeAttribute('hidden'); else els[i].setAttribute('hidden', '');
    }
  }

  function drawer() { return document.querySelector('[data-wishlist-drawer]'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wishlist-drawer-open');
    renderDrawer();
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wishlist-drawer-open');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=200';
    var url = p.url || (root + 'products/' + p.handle);
    var price = (typeof p.price === 'number') ? money(p.price) : '';
    return '<div class="wishlist-item" data-wishlist-item="' + esc(p.handle) + '">' +
      '<a class="wishlist-item__image" href="' + esc(url) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="wishlist-item__info">' +
      '<a class="wishlist-item__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
      '<div class="wishlist-item__price">' + price + '</div>' +
      '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + esc(p.handle) + '">Remove</button>' +
      '</div></div>';
  }

  function renderDrawer() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var handles = read();
    if (!handles.length) { grid.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>'; return; }
    grid.innerHTML = '<p class="wishlist-loading">Loading…</p>';
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var byHandle = {};
      for (var i = 0; i < list.length; i++) { if (list[i]) byHandle[list[i].handle] = list[i]; }
      var pruned = handles.filter(function (h) { return byHandle[h]; });
      if (pruned.length !== handles.length) { write(pruned); syncCount(); syncButtons(); }
      if (!pruned.length) { grid.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>'; return; }
      grid.innerHTML = pruned.map(function (h) { return cardHTML(byHandle[h]); }).join('');
    });
  }

  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches && el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '.js-wishlist-btn');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var h = btn.getAttribute('data-wishlist-handle');
      if (h) { toggle(h); syncButtons(); syncCount();
        if (drawer() && drawer().getAttribute('aria-hidden') === 'false') renderDrawer(); }
      return;
    }
    if (closest(e.target, '[data-wishlist-open]')) { e.preventDefault(); openDrawer(); return; }
    if (closest(e.target, '[data-wishlist-close]')) { e.preventDefault(); closeDrawer(); return; }
    var rm = closest(e.target, '[data-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      var hh = rm.getAttribute('data-wishlist-remove'), a = read(), i = a.indexOf(hh);
      if (i !== -1) { a.splice(i, 1); write(a); }
      syncButtons(); syncCount(); renderDrawer();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeDrawer(); });

  function init() { syncButtons(); syncCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
